import * as z from 'zod';
import client from '../client';

import { SEO, Localization } from '../strapiSchema';
import { blocksSchema } from '../blocksSchema';
import { blocks, seo, localizations } from '../strapiBlocks';
import { isNotFoundError, logMissingResource, PRIMARY_LOCALE } from '../strapiLocale';

const OffreEtServicesZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  blocks: z.array(blocksSchema),
  seo: SEO,
  localizations: z.array(Localization),
  locale: z.string(),
});

export type OffreEtServicesType = z.infer<typeof OffreEtServicesZod>;

const getOffresEtServices = async (
  locale: string = PRIMARY_LOCALE,
): Promise<OffreEtServicesType | null> => {
  try {
    const response = await client.get('/api/offres-et-services', {
      params: {
        locale,
        populate: {
          blocks,
          seo,
          localizations,
        },
      },
    });

    if (!response.data?.data) {
      if (locale !== PRIMARY_LOCALE) {
        logMissingResource('offres-et-services', locale);
        return null;
      }
      throw new Error('No offres et services page found');
    }

    return OffreEtServicesZod.parseAsync(response.data.data);
  } catch (error) {
    if (locale !== PRIMARY_LOCALE && isNotFoundError(error)) {
      logMissingResource('offres-et-services', locale);
      return null;
    }

    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    throw new Error(`API response do not match Offre Et Services structure : ${errorMessage}`);
  }
};

export {
  getOffresEtServices,
};
